import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  registeredIds: [],
};

export const unsavedWorkSlice = createSlice({
  name: 'unsavedWork',
  initialState,
  reducers: {
    register(state, action) {
      if (!state.registeredIds.includes(action.payload)) {
        state.registeredIds.push(action.payload);
      }
    },
    unregister(state, action) {
      state.registeredIds = state.registeredIds.filter(
        (id) => id !== action.payload
      );
    },
  },
});

export const {register, unregister} = unsavedWorkSlice.actions;
export default unsavedWorkSlice.reducer;

export const selectHasUnsavedWork = (state) =>
  state.unsavedWork.registeredIds.length > 0;
